import React from 'react';

import LoadImage from './load-image';
import './scoring-test-alert.css';

export const ScoringTestAlert: React.FC = () => {
  const title = `Scoring your test...`;
  const description = `Please wait while we score your test.`;
  return (
    <div className="scoring-test-alert-container">
      <div className="scoring-test-alert">
        <div className="scoring-test-alert-title">{title}</div>
        <div>{description}</div>
      </div>
      <LoadImage key="load" className="relative" />
    </div>
  );
};
